import { Alert } from "@heroui/react";

import { aed } from "@/components/sales/shared";
import { BelowCostWarning } from "@/types";

const th = "text-muted px-2 py-2 text-xs font-medium";

export const PromotionBelowCostWarning = ({
  warning,
}: {
  warning: BelowCostWarning;
}) => {
  if (warning.count === 0) return null;

  return (
    <section className="flex flex-col gap-3">
      <Alert status="warning">
        <Alert.Indicator />
        <Alert.Content>
          <Alert.Title>
            {warning.count} product{warning.count === 1 ? "" : "s"} sell below
            cost with this promotion
          </Alert.Title>
          <Alert.Description>
            {warning.count > warning.products.length
              ? `The ${warning.products.length} largest losses are listed. `
              : ""}
            Cost is the supplier offer price when there is one.
          </Alert.Description>
        </Alert.Content>
      </Alert>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-separator border-b">
              <th className={`${th} text-start`}>Product</th>
              <th className={`${th} text-end`}>Price</th>
              <th className={`${th} text-end`}>Promoted</th>
              <th className={`${th} text-end`}>Cost</th>
            </tr>
          </thead>
          <tbody className="divide-separator divide-y">
            {warning.products.map((product) => (
              <tr key={product.id}>
                <td className="px-2 py-2 font-medium">{product.name}</td>
                <td className="px-2 text-end whitespace-nowrap tabular-nums">
                  {aed(product.price)}
                </td>
                <td className="px-2 text-end whitespace-nowrap text-(--danger) tabular-nums">
                  {aed(product.promotedPrice)}
                </td>
                <td className="px-2 text-end whitespace-nowrap tabular-nums">
                  {aed(product.costPrice)}
                  {product.supplierOfferPrice !== null ? (
                    <span className="text-muted block text-xs">Offer</span>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
